<template>
 <transition name="slide">
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <validation-observer v-slot="{ invalid }">
    <v-row>
      <v-col cols="12" sm="6">
  <!-- <v-dialog v-model="foodAddModalVisible" max-width="700"> -->
      <base-material-card class="px-5 py-3" color="primary">
          <template v-slot:heading>
              <div class="subheading font-weight-light mx-3 white--text"  align="center" style="align-self: center"  v-if="activeDateString != 'Today'">
                <v-icon left class="white--text">mdi-alert</v-icon>
                Logging for {{ activeDateString }}
              </div>
            <v-tabs
              v-model="tab"
              background-color="transparent"
              slider-color="white"
            >
              <v-tab class="mr-3" href="#tab-1">
                <v-icon class="mr-2">
                  mdi-magnify
                </v-icon>
                Search
              </v-tab>
              <v-tab class="mr-3" href="#tab-2">
                <v-icon class="mr-2">
                  mdi-history
                </v-icon>
                Recent
              </v-tab>
            </v-tabs>
            </template><v-tabs-items v-model="tab">
                <v-tab-item value="tab-1">
                  <v-row align="center">
                    <v-col cols="12">
                      <v-text-field
                        v-model="searchTerm"
                        label="Search"
                        :loading="searching"
                        @keydown.enter="search({term: searchTerm})"
                      >
                        <template v-slot:append>
                          <v-btn @click="search({term: searchTerm})" :loading="searching" text color="primary">
                            <v-icon left>mdi-magnify</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-col cols="12" class="pt-0">
                    <v-data-table
                      :headers="foodHeader"
                      :items="searchResults"
                      :items-per-page="5"
                      hide-default-header
                      dense
                      no-data-text="No results"
                      :sort-by="sortBy"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                          <td>
                            <v-row>
                          <v-col cols="12" class="pt-0">
                            {{ item.n }} 
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <small>Portion size: {{ item.p }}{{ item.u }} ({{ item.g.map(g => `${g.p} ${g.n}`).join(',') }})</small>
                          </v-col>
                          <v-col cols="3" class="py-0">
                          <v-chip
                            label outlined x-small pill
                            :class="choiceClass(item.c)"
                            :text-color="choiceClass(item.c)"
                            v-text="choiceText(item.c)"
                          >
                          </v-chip>
                          </v-col>
                          <v-col cols="3" class="py-0" align="right">
                            <v-btn text :ripple=false color="primary" small @click="addFood(item)" v-if="!foodAdded(item)" :disabled="saving">
                          Add
                        </v-btn>
                        <v-btn text :ripple=false color="error" small @click="remFood(item)" v-if="foodAdded(item)" :disabled="saving">
                          Remove
                        </v-btn>
                          </v-col>
                            </v-row>
                          </td>
                        </tr>                        
                      </template>
                    </v-data-table>
                  </v-col>
                </v-tab-item>
                <v-tab-item value="tab-2" >
                                    <v-row align="center">
                    <v-col cols="12">
                      <v-text-field
                        v-model="recentSearch"
                        label="Filter"
                        append-icon="mdi-magnify"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                                    <v-col cols="12" class="pt-0">
                    <v-data-table
                      :headers="recentFoodHeader"
                      :items="recentFoodEntries"
                      :items-per-page="5"
                      :search="recentSearch"
                        hide-default-header
                      dense
                      no-data-text="No results"
                      :sort-by="sortBy"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                          <td>
                            <v-row>
                          <v-col cols="12" class="pt-0">
                            {{ item.n }} 
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <small>Portion size: {{ item.p }}{{ item.u }} ({{ item.g.map(g => `${g.p} ${g.n}`).join(',') }})</small>
                          </v-col>
                          <v-col cols="3" class="py-0">
                          <v-chip
                            label outlined x-small pill
                            :class="choiceClass(item.c)"
                            :text-color="choiceClass(item.c)"
                            v-text="choiceText(item.c)"
                          >
                          </v-chip>
                          </v-col>
                          <v-col cols="3" class="py-0" align="right">
                            <v-btn text :ripple=false color="primary" small @click="addFood(item)" v-if="!foodAdded(item)" :disabled="saving">
                          Add
                        </v-btn>
                        <v-btn text :ripple=false color="error" small @click="remFood(item)" v-if="foodAdded(item)" :disabled="saving">
                          Remove
                        </v-btn>
                          </v-col>
                            </v-row>
                          </td>
                        </tr>                        
                      </template>
                    </v-data-table>
                  </v-col>
                </v-tab-item>
              </v-tabs-items>
          
            </base-material-card>


      </v-col>
      <v-col cols="12" sm="6">
        <base-material-card
          icon="mdi-nutrition"
          color="secondary"
          title="Portion Planner"
          class="px-5 py-1 sticky"
          :loading="saving"
        >
        <div v-if="selectedFood.length == 0">
          <p class="paragraph text-center pt-5 grey--text">
            No food added yet.
          </p>
          <ol class="grey--text">
            <li>Search for food or browse Recent</li>
            <li>Click add</li>
            <li>Repeat until all your food is added</li>
            <li>Edit portion size and select meals</li>
            <li>Click Save</li>
          </ol>
        </div>
            <v-list-item dense two-line v-for="food in selectedFood" :key="food.n" class="px-0">
              
              <v-list-item-content class="pt-5">
                <v-list-item-title class="display-1 primary pa-2 white--text">{{ food.n }}</v-list-item-title>
                <v-list-item-subtitle class="text-right"><small>Portion size: {{ food.p }}{{ food.u }} ({{ food.g.map(g => `${g.p} ${g.n}`).join(',') }})</small></v-list-item-subtitle>

                  

                <v-col cols="5" class="py-0">
                <validation-provider rules="requiredNumeric" v-slot="{ errors }">
                  <v-text-field
                    :error-messages="errors"
                    label="Quantity"
                    type="number"
                    hint="Quantity"
                    v-model="food.Used.q"
                  />
                  </validation-provider>  
                </v-col>   
                <v-col cols="7" class="py-0">
                  <v-select :items="units(food)" value="Portion" v-model="food.Used.u"></v-select>
                </v-col>
                <v-col cols="12" class="py-0">                  
                <validation-provider rules="required" v-slot="{ errors }">
                  <v-select
                    menu-props="top"
                    v-model="food.Used.m"
                    :items="meals"
                    :error-messages="errors"
                    attach
                    chips
                    small-chips
                    label="Meal"
                    multiple
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        primary
                        label
                        small
                        dark
                        color="secondary"
                      >
                        {{item}}
                      </v-chip>
                    </template>
                  </v-select>
                  </validation-provider>  
                </v-col>
                <v-col cols="12" align="right">               
                  <v-btn text :ripple=false color="error" small @click="remFood(food)">
                    Remove
                  </v-btn>
                </v-col>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
              <v-spacer />              
              <v-btn type="submit" color="primary" :disabled="invalid || selectedFood.length == 0" @click="savePortions" :loading="saving" >Save</v-btn>
            </v-card-actions>
        </base-material-card>
      </v-col>
  <!-- </v-dialog> -->
    </v-row>
    </validation-observer>
  </v-container>
 </transition>
</template>
<script>
import moment from 'moment'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  name: 'FoodAdd',
  data() {
    return {
      isMobile: false,
      date: '',
      weight: '',
      searchTerm: '',
      busy: false,
      datepicker: false,
      tab: undefined,
      selectedFood: [],
      recentSearch: '',
      meals: ['Breakfast', 'Lunch', 'Dinner', 'Snack'],
      recentFoodHeader: [{
          text: 'Food',
          align: 'start',
          value: 'n',
          sortable: false
        }
      ],
      foodHeader: [
        {
          text: 'Food',
          align: 'start',
          value: 'n',
          sortable: false
        },        
        {
          text: 'Groups',
          align: 'center',
          value: 'g',
          sortable: false
        },        
        {
          text: 'Choice',
          align: 'end',
          value: 'c',
          sortable: false
        },
        {
          text: '',
          align: 'end',
          value: 'add',
          sortable: false
        }
      ],
      sortBy: ['c', 'n']
    };
  },
  computed: {
    ...mapState('Ui', ['showFoodAddModal']),
    ...mapState('Profile', ['profile']),
    ...mapState('Food', ['searching', 'searchResults', 'saving']),
    ...mapState('Diary', ['activeDate']),
    ...mapGetters('Diary', ['recentFoodEntries']),
    foodAddModalVisible: {
      get: function() {
        return this.showFoodAddModal
      },
      set: function() {
        this.setFoodAddModal(false)
      }
    },
    activeDateString() {
      const formattedDate = moment(this.activeDate).format('D MMM YYYY')
      return moment().format('D MMM YYYY') == formattedDate ? 'Today' : formattedDate
    }
  },
  methods: {
    ...mapMutations('Ui', ['setFoodAddModal', 'showSnackbar' ]),
    ...mapActions('Diary', ['addWeight']),
    ...mapActions('Food', ['search', 'saveFood']),
    addFood(item) {
      //this.selectedFood.push(item);
      if (this.selectedFood.findIndex(food => food.n == item.n) == -1) { 
        // HACK: add the used object to map to
        item.Used = {
          q: 1,
          u: 'Portion',
          m: []
        }
        item.m = undefined
        this.selectedFood.push(item)
      }
    },
    remFood(item) {
      const idx = this.selectedFood.findIndex(food => {
        return food.n == item.n
        });
      this.selectedFood.splice(idx, 1)
    },
    foodAdded(item) {
      return this.selectedFood.findIndex(food => food.n == item.n) > -1;
    },
    units(item) {
      return ['Portion', ...item.u ];
    },
    choiceClass: function(fieldVal) {
      switch (fieldVal) {
        case 1: return 'green'
        case 2: return 'orange'
        case 3: return 'gray'
        case 4: return 'red'
      }
      return 'white';
    },
    choiceText: function(fieldVal) {
      switch (fieldVal) {
        case 1: return 'best'
        case 2: return 'better'
        case 3: return 'breakout'
        case 4: return 'good'
      }
      return 'white';
    },
    onResize () {
      this.isMobile = window.innerWidth < 600
    },
    savePortions() {
      this.saveFood(this.selectedFood)
        .then(() => {
          // success
          this.selectedFood = []
          this.showSnackbar({
            snackbarType: 'success',
            snackbarMessage: 'Portions were saved successfully',
          });
        })
        .catch(() => {
          // error
          this.showSnackbar({
            snackbarType: 'error',
            snackbarMessage: 'There was an error saving the portions.  Please try again.',
          });
        })
    }
  },
  mounted: function() {     
    this.onResize()
  },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
};
</script>
<style>
  .sticky {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 95px;
  }
  .v-data-table td {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .v-data-table__wrapper {
    overflow-x: hidden;
  }
</style>